import React, { useMemo } from 'react'
import { Image } from 'antd';
import WeddingSection from './WeddingSection'

export default function IntroSection({ invitation, places }) {
    const days = useMemo(() => {
        return places.map(place => place.open_time)
            .sort((a, b) => a.valueOf() - b.valueOf())
            .map(day => day.format("DD/MM/YYYY"))
    }, [places])

    return (
        <WeddingSection>

            <div style={{ 
                position: "relative", 
                textAlign: "center",
                marginTop: "-14px",
                marginLeft: "-15px",
                marginRight: "-15px",
                marginBottom: "-35px",
                }}>

                <Image
                    src="/img/intro-cdcr-r.jpg"
                    className='fade-in-intro'
                    preview={false}
                    style={{
                        height: "100vh",
                        objectFit: "cover",
                        // WebkitMaskImage: `
                        // linear-gradient(
                        //     to bottom,
                        //     rgba(0,0,0,1) 0%,
                        //     rgba(0,0,0,1) 60%,
                        //     rgba(0,0,0,0.8) 75%,
                        //     rgba(0,0,0,0.4) 85%,
                        //     rgba(0,0,0,0) 100%
                        // )`,
                        // maskImage: `
                        // linear-gradient(
                        //     to bottom,
                        //     rgba(0,0,0,1) 0%,
                        //     rgba(0,0,0,1) 60%,
                        //     rgba(0,0,0,0.8) 75%,
                        //     rgba(0,0,0,0.4) 85%,
                        //     rgba(0,0,0,0) 100%
                        // )`,
                    }}
                />

                <div
                    style={{
                        position: "absolute",
                    }}
                />

                
                {/* <div
                    style={{
                        position: "absolute",
                        top: "20%",
                        left: "50%",
                        // transform: "translate(-50%, -50%)",
                        width: "90%",
                        // fontSize: "5%",
                        color:  "#3F0115" ,
                        fontFamily: "'Charm', cursive"
                    }}>
                    <span>SAVE THE DATE</span>
                </div> */}

                <div
                    className="block-wrapper fade-up-text"
                    style={{
                        position: "absolute",
                        top: "90%",
                        left: "50%",
                        // transform: "translate(-50%, -50%)",
                        width: "90%",
                        // fontSize: "5%",
                        color:  "#3F0115" 
                    }}
                >

                    <div
                        style={{
                            // paddingTop: "4vh",
                            fontFamily: "'Gowun Dodum', sans-serif",
                            fontSize: "25px",
                            // fontWeight: "500",
                            // color: "#fff",
                            // fontSize: "clamp(12px, 5vw, 24px)"
                        }}
                    >
                        <span>
                            TÂM ĐIỀN & HÀ TRANG
                        </span>
                    </div>

                    <div
                        style={{
                            fontFamily: "'Gowun Dodum', sans-serif",
                            fontSize: "20px"
                        }}
                    >
                        {(invitation && (!invitation.data.both_tab || invitation.data.both_tab === 0)) ? invitation.place.open_time.format("DD/MM/YYYY") : <>
                            {days.map(day => <div key={day}>
                                {day}
                            </div>)}
                        </>}
                    </div>

                    {invitation && <div
                        style={{
                            fontFamily: "'Lexend', cursive",
                            // fontFamily: "'Gowun Dodum', sans-serif",
                            // fontSize: "18px",
                            // fontWeight: 500,
                            marginTop: 55,
                        }}
                    >
                        <span
                        style={{
                            fontSize: "14px",
                            fontWeight: 300,
                        }}>TRÂN TRỌNG KÍNH MỜI</span><br/>

                        <span
                        style={{
                            fontSize: "18px",
                            fontWeight: 300,
                        }}>{invitation.data.displayname}</span>
                    </div>}
                </div>

            </div>

        </WeddingSection>
    );
}